module.exports = __webpack_public_path__ + "img/Mid-AutumnFestival-tw.3ed36ed5.jpg";